import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout")({
    component: ToolStructureLayout,
    loader: ({ context: { t } }) => ({
        breadcrumb: t("pages.tool.structure.title"),
    }),
});

function ToolStructureLayout() {
    return <Outlet />;
}
